import * as core from '../../../../../../../core'

import { query } from './ideas-table-page.query'

export const RESOURCE = {
  payload: {
    alias: 'ideas.table.page',
    description:
      'Ideas table page used to display and explore innovation ideas with all fields.',
    name: 'Ideas Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
